var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 10.0007C2.6665 10.0007 3.33317 9.33398 5.33317 9.33398C7.33317 9.33398 8.6665 10.6673 10.6665 10.6673C12.6665 10.6673 13.3332 10.0007 13.3332 10.0007V2.66732C13.3332 2.66732 12.6665 3.33398 10.6665 3.33398C8.6665 3.33398 7.33317 2.00065 5.33317 2.00065C3.33317 2.00065 2.6665 2.66732 2.6665 2.66732M2.6665 14.6673L2.6665 1.33398",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.400d03149bc0373dd8bdf480e934bfdd.svg";
export { ForwardRef as ReactComponent };